// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"124":"ac8428ed","264":"19071c67","429":"ed3d32ff","480":"1ce312fa","507":"64bae3e6","638":"b516e270","801":"eeadfa2a"}[chunkId] + ".chunk.js";
};